import { transactions } from './transactions'
import { canvasPixels } from './canvasPixels'
import { canvasPainters } from './canvasPainters'
import { selectedPixels } from './selectedPixels'

export const LocalStorageManager = {
  transactions,
  canvasPixels,
  canvasPainters,
  selectedPixels,
}


// WEBPACK FOOTER //
// ./src/localStorage/index.js